import { render, staticRenderFns } from "./fireFightingLayoutDetail.vue?vue&type=template&id=5bff6c0e"
import script from "./fireFightingLayoutDetail.vue?vue&type=script&lang=js"
export * from "./fireFightingLayoutDetail.vue?vue&type=script&lang=js"
import style0 from "./fireFightingLayoutDetail.vue?vue&type=style&index=0&id=5bff6c0e&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bff6c0e')) {
      api.createRecord('5bff6c0e', component.options)
    } else {
      api.reload('5bff6c0e', component.options)
    }
    module.hot.accept("./fireFightingLayoutDetail.vue?vue&type=template&id=5bff6c0e", function () {
      api.rerender('5bff6c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/layout/fireFightingLayoutDetail.vue"
export default component.exports